var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.536 13.689c.473-.003 1.88-.13 2.475 1.88.401 1.355 1.04 3.573 1.917 6.655h.357c.94-3.25 1.587-5.468 1.939-6.654.601-2.031 2.106-1.881 2.708-1.881h4.643v14.443h-4.733v-8.511h-.317l-2.638 8.511h-3.56l-2.639-8.518h-.317v8.518H7.639V13.69h4.897zm20.834 0v8.518h.378l3.209-7.004c.623-1.394 1.95-1.514 1.95-1.514h4.58v14.443h-4.831v-8.518h-.378l-3.146 7.005c-.623 1.387-2.013 1.513-2.013 1.513h-4.58V13.69h4.831zm26.816 6.864c-.674 1.91-2.79 3.277-5.134 3.277h-5.066v4.302h-4.594v-7.58h14.793z",
    fill: "#3A9258"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.273 13.69H45.15c.241 3.215 3.01 5.968 5.877 5.968h9.477c.547-2.673-1.335-5.969-5.23-5.969z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1589.85,
    y1: 389.123,
    x2: 45.15,
    y2: 389.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F5CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02AEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.14d4a14b61a8f88b4d058c5fce807ef2.svg";
export { ForwardRef as ReactComponent };